import SessionKit from './session-kit';

if (module.hot) {
  module.hot.accept();
}

window.SessionKit = SessionKit;

if (window.onSessionKitReady && typeof window.onSessionKitReady === 'function') {
  window.onSessionKitReady();
}

export default SessionKit;
